import { ApolloClient, createHttpLink, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import createUploadLink from "apollo-upload-client/createUploadLink.mjs";
import {store} from "../store/store";
import { logoutUser } from "../store/userSlice";
import { enqueueSnackbar } from "notistack";


const URL = process.env.REACT_APP_GRAPHQL_URL;
// const URL = "https://dev-api.mamaket.com/graphql";

const httpLink = createUploadLink({
  uri: URL,
 
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem("mamaketUserToken");

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
      "content-type": "application/json",
        'apollo-require-preflight': true,
    },
  };
});

// Error handling link for token expiration and network issues
const errorLink = onError(({ graphQLErrors, networkError, operation, forward }) => {
  // Handle GraphQL errors
  if (graphQLErrors) {
    for (let err of graphQLErrors) {
      // Check for authentication errors
      if (err.extensions?.code === 'UNAUTHENTICATED' || 
          err.message.includes('Not authorized') ||
          err.message.includes('unauthorized') ||
          err.message.includes('Authentication required')) {
        
        // Dispatch logout action
        store.dispatch(logoutUser());
        
        // Clear localStorage
        localStorage.removeItem('mamaketUserToken');
        localStorage.removeItem('persist:root'); // Clear persisted Redux state if any
        
        // Show notification
        enqueueSnackbar('Your session has expired. Please log in again.', { 
          variant: 'warning',
          persist: false,
          autoHideDuration: 5000
        });
        
        // Redirect to login page
        window.location.href = '/login';
        
        return;
      }
      
      console.error(`GraphQL error: ${err.message}`);
    }
  }
  
  // Handle network errors
  if (networkError) {
    console.error('Network error:', networkError);
    
    // Check for 401 Unauthorized network error
    if (networkError.statusCode === 401) {
      // Dispatch logout action
      store.dispatch(logoutUser());
      
      // Clear localStorage
      localStorage.removeItem('mamaketUserToken');
      localStorage.removeItem('persist:root');
      
      // Show notification
      enqueueSnackbar('Your session has expired. Please log in again.', { 
        variant: 'warning',
        persist: false,
        autoHideDuration: 5000
      });
      
      // Redirect to login page
      window.location.href = '/login';
      
      return;
    }
    
    // Handle other network errors
    if (networkError.name === 'NetworkError' || !navigator.onLine) {
      enqueueSnackbar('Network error. Please check your connection.', { 
        variant: 'error',
        persist: false,
        autoHideDuration: 3000
      });
    }
  }
});

const client = new ApolloClient({
  link: errorLink.concat(authLink.concat(httpLink)),
  cache: new InMemoryCache(),
});

export default client;
